import { render, staticRenderFns } from "./MarketRuleWay.vue?vue&type=template&id=45a3df6a&scoped=true"
import script from "./MarketRuleWay.vue?vue&type=script&lang=js"
export * from "./MarketRuleWay.vue?vue&type=script&lang=js"
import style0 from "./MarketRuleWay.vue?vue&type=style&index=0&id=45a3df6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a3df6a",
  null
  
)

export default component.exports